import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  StepButton,
  Step,
  StepLabel,
  Stepper
} from '@material-ui/core/';
import withStyles from '@material-ui/core/styles/withStyles';
import React, { Fragment } from 'react';
import { resolveRedirectTo, showNotification } from 'react-admin';
import ResourceUploadApi from '../../core/apis/ResourceUploadApi';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import Confirm from '../../core/components/forked/layout/Confirm';
import AssignSplitStep from './uploadsteps/SplitStep/AssignSplitStep';
import DetailsStep from './uploadsteps/DetailsStep';
import FundsStep from './uploadsteps/FundStep/FundsStep';
import InvestorsStep from './uploadsteps/InvestorsStep';
import SummaryStep from './uploadsteps/SummaryStep';
import DeliveryStep from './uploadsteps/DeliveryStep';
import EmailDialog from './uploadsteps/emailDialog/EmailDialog';
import { connect } from 'react-redux';
import { getIcError } from '../../core/providers/utils';
import { parse } from '../../core/components/forked/stringify';
import TenantConfigurationApi from '../../core/apis/TenantConfigurationApi';
import dataProvider from '../../core/providers/IccUserDataProvider';

const styles = {
  stepper: {
    backgroundColor: '#FFFFFF',
    padding: '0 0 0px',
    display: 'inline-flex'
  },
  leftWrapper: {
    flexGrow: 1
  },
  button: {
    '& span': {
      padding: 0
    }
  },
  secondaryButton: {
    border: '1px solid #E0E0E0',
    '& span': {
      padding: 0
    }
  },
  root: {
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  dialogContent: {
    display: 'flex',
    flex: 1,
    padding: '0px'
  },
  stepperContainer: {
    backgroundColor: '#FFFFFF',
    padding: '11px 8px',
    height: '24px',
    borderBottom: '1px solid #E0E0E0'
  },
  stepButton: {
    margin: 0,
    padding: 0
  },
  stepContainer: {
    display: 'flex',
    width: '100%',
    padding: '16px',
    overflowX: 'auto',
    '& > div': {
      width: 'inherit'
    },
    '& .simple-form': {
      width: '100%'
    }
  },
  noPaddingContainer: {
    display: 'flex',
    width: '100%',
    padding: '0px',
    overflowX: 'auto',
    '& > div': {
      width: 'inherit'
    },
    '& .simple-form': {
      width: '100%'
    }
  }
};

/**
 * Document upload driver.
 * It handles the various steps under it as separate forms.
 */
class ResourceUploadCreate extends React.Component {
  // Current from (FormApi object)
  currentForm;

  // uploadType
  bulkType;

  /**
   * Get active Step
   * @param {*} props
   */
  constructor(props) {
    super(props);

    // List of steps
    const { permissions = [] } = props;
    const hasApprovePermission = permissions.includes(
      'AUTH_APPROVE_RESOURCE_UPLOAD'
    );
    const hasSendEmailPermission = permissions.includes(
      'AUTH_SEND_EMAIL_NOTIFICATION'
    );

    this.steps = [
      {
        name: 'details',
        label: 'Document Details',
        component: DetailsStep,
        bulkUploadStep: true,
        singleUploadStep: true,
        approveButton: false,
        nextButton: true,
        backButton: false
      },
      {
        name: 'funds',
        label: 'Select Funds',
        component: FundsStep,
        bulkUploadStep: true,
        singleUploadStep: true,
        approveButton: false,
        nextButton: true,
        backButton: true
      },
      {
        name: 'investors',
        label: 'Select Investors',
        component: InvestorsStep,
        bulkUploadStep: false,
        singleUploadStep: true,
        approveButton: false,
        nextButton: true,
        backButton: true
      },
      {
        name: 'matching',
        label: 'Matching',
        component: AssignSplitStep,
        bulkUploadStep: true,
        singleUploadStep: false,
        approveButton: false,
        nextButton: true,
        backButton: true
      },
      {
        name: 'summary',
        label: 'Summary',
        component: SummaryStep,
        bulkUploadStep: true,
        singleUploadStep: true,
        approveButton: hasApprovePermission,
        nextButton: hasSendEmailPermission,
        backButton: true
      },
      {
        name: 'delivery',
        label: 'Delivery',
        component: DeliveryStep,
        bulkUploadStep: true,
        singleUploadStep: true,
        approveButton: false,
        nextButton: false,
        backButton: true
      }
    ];

    this.bulkType = this.getBulkMode();
    const fundLevelDoc = props.record ? props.record.allInvestors : false;

    const steps = this.getPopupSteps(fundLevelDoc);

    this.state = {
      activeStep: 0, // Current step,
      targetStep: -1,
      closing: false, // Dialog box closing
      resourceupload: this.props.record || {}, // Resourceupload to edit OR Resourceupload empty object
      confirmDialogIsOpen: false,
      fundLevelDocumentsChecked: fundLevelDoc,
      confirmUpdateDialogIsOpen: false,
      confirmUpdateAndCloseDialogIsOpen: false,
      openEmailModal: false,
      popupSteps: steps,
      submitInProgress: false,
      uploadChanged: false,
      isFundLevelFlowAvailable: false,
      isDocumentTagLoading: true,
      setMarkReviewedClicked: false,
      isDocReviewEnabled: false,
      confirmApproveWithoutReviewDialogIsOpen: false
    };
  }

  componentDidMount = async () => {
    try {
      const resDocumentTag = await TenantConfigurationApi.get('Document_Tag');
      const isDocumentTagActiveValue = resDocumentTag.pageData[0].value;
      const isDocumentTagFlagActive = !(
        isDocumentTagActiveValue === 'false' ||
        isDocumentTagActiveValue === '0' ||
        !isDocumentTagActiveValue
      );
      const resFITag = await dataProvider('GET_LIST', 'fundinvestortags', {});
      this.setState({
        isFundLevelFlowAvailable: isDocumentTagFlagActive && resFITag.total > 0
      });
      await this.fetchDocReviewProcessConfig();
    } catch (error) {
      console.error('Error: ', error);
    } finally {
      this.setState({ isDocumentTagLoading: false });
    }
  };

  fetchDocReviewProcessConfig = async () => {
    try {
      const response = await TenantConfigurationApi.get(
        'DocumentUpload-Review-Process'
      );
      const isEnabled = response.pageData[0]?.value === '1';
      this.setState({ isDocReviewEnabled: isEnabled });
    } catch (error) {
      console.error(
        'Error fetching DocumentUpload-Review-Process config:',
        error
      );
    }
  };

  getBulkMode() {
    const {
      record,
      location: { search }
    } = this.props;
    if (record && record.profileData) {
      return record.profileData.uploadType === 'BULK';
    }
    const queryParams = parse(search);
    return queryParams.mode === 'bulk';
  }

  getPopupSteps(isFundLevelDoc) {
    const { permissions = [] } = this.props;
    const hasSendEmailPermission = permissions.includes(
      'AUTH_SEND_EMAIL_NOTIFICATION'
    );
    return this.bulkType
      ? this.steps.filter(function(step) {
          return (
            step.bulkUploadStep === true &&
            !(!hasSendEmailPermission && step.name === 'delivery')
          );
        })
      : this.steps.filter(function(step) {
          return (
            step.singleUploadStep === true &&
            !(isFundLevelDoc && step.name === 'investors') &&
            !(!hasSendEmailPermission && step.name === 'delivery')
          );
        });
  }

  handleOpenEmailModal = (
    recipientsListSelected,
    recipientsList,
    notificationMethod
  ) => {
    this.setState({
      openEmailModal: true,
      recipientsListSelected,
      recipientsList,
      notificationMethod
    });
  };

  setSplitStatus = status => {
    this.setState({ splitStatus: status });
  };

  getActiveStep(steps) {
    const {
      activeStep,
      uploadChanged,
      isFundLevelFlowAvailable,
      isDocumentTagLoading,
      fundLevelDocumentsChecked
    } = this.state;
    const step = steps[activeStep];
    const { classes, permissions = [], ...rest } = this.props;
    const hasSendEmailPermission = permissions.includes(
      'AUTH_SEND_EMAIL_NOTIFICATION'
    );

    return (
      <step.component
        {...rest}
        onFormInit={this.onFormInit}
        onSubmitEnd={this.onSubmitEnd}
        openEmailModal={this.handleOpenEmailModal}
        handleFundLevelDocumentsChanged={this.handleFundLevelDocumentsChanged}
        resourceupload={this.state.resourceupload}
        fundLevelDocument={this.state.fundLevelDocumentsChecked}
        setSplitStatus={this.setSplitStatus}
        bulkMode={this.bulkType}
        variant="standard"
        handleResetActionButtons={this.handleResetActionButtons}
        handleResetActionButtonsFileTooLarge={
          this.handleResetActionButtonsFileTooLarge
        }
        disableActionButtons={this.disableActionButtons}
        uploadChanged={uploadChanged}
        handleUploadChange={this.handleUploadChange}
        hasSendEmailPermission={hasSendEmailPermission}
        permissions={permissions}
        validateBatch={this.validateBatch}
        handleResetClosingState={this.handleResetClosingState}
        isFundLevelFlowAvailable={isFundLevelFlowAvailable}
        isDocumentTagLoading={isDocumentTagLoading}
        fundLevelDocumentsChecked={fundLevelDocumentsChecked}
      />
    );
  }

  handleCloseEmail = () => {
    this.setState({ openEmailModal: false });
  };

  disableActionButtons = () => {
    const { submitInProgress } = this.state;
    if (!submitInProgress) {
      this.setState({ submitInProgress: true });
    }
  };
  handleResetActionButtons = () => {
    const { submitInProgress } = this.state;
    if (submitInProgress) {
      this.setState({ submitInProgress: false });
    }
  };
  handleResetActionButtonsFileTooLarge = () => {
    this.setState({ submitInProgress: false });
  };

  //used only on Matching Step where dialog is should not be closed even if submit fails
  handleResetClosingState = () => {
    this.setState({ closing: false });
  };

  renderStepper = (popupSteps, activeStep, classes, isEdit, resourceupload) => (
    <div className={classes.stepperContainer}>
      <Stepper
        nonLinear={isEdit}
        activeStep={activeStep}
        className={classes.stepper}
      >
        {popupSteps.map(
          (step, index) =>
            step.name !== 'sendEmail' && (
              <Step key={step.name}>
                <StepButton
                  onClick={() => this.handleStep(index)}
                  className={classes.stepButton}
                  disabled={
                    (step.name === 'delivery' &&
                      resourceupload.batchStatus !== 'A') ||
                    !isEdit
                  }
                >
                  <StepLabel>{step.label}</StepLabel>
                </StepButton>
              </Step>
            )
        )}
      </Stepper>
    </div>
  );

  renderConfirmModals = (
    confirmDialogIsOpen,
    confirmUpdateDialogIsOpen,
    confirmUpdateAndCloseDialogIsOpen,
    resourceupload,
    specialTextForMatchingStepLeaveModal
  ) => (
    <>
      <Confirm
        isOpen={confirmDialogIsOpen}
        title="Close Window?"
        content={
          <div>
            <p style={{ margin: 0 }}>
              You are about to return to the Documents page.
            </p>
            {specialTextForMatchingStepLeaveModal}
          </div>
        }
        onConfirm={this.handleConfirm}
        onClose={this.handleConfirmDialogClose}
        confirm="ra.action.close"
      />
      <Confirm
        isOpen={confirmUpdateDialogIsOpen || confirmUpdateAndCloseDialogIsOpen}
        title={
          resourceupload.batchStatus === 'A'
            ? 'Batch Status Change'
            : 'Batch Change'
        }
        content={
          resourceupload.batchStatus === 'A'
            ? 'The changes you made will set the status of this Batch to ‘Pending’.'
            : 'You are amending the Document Profile - This action will require you to re-select the Funds/Investors associated with this batch. NOTE that any active document in the batch will also be affected. Do you wish to proceed?'
        }
        onConfirm={this.handleConfirmUpdate}
        onClose={this.handleConfirmUpdateDialogClose}
      />
      <Confirm
        isOpen={this.state.confirmApproveWithoutReviewDialogIsOpen}
        title="Approve Document?"
        content={
          <p>
            Batch details have not been Marked as Reviewed. Do you want to
            proceed with Approval?
          </p>
        }
        onConfirm={() => {
          this.setState(
            {
              approveClicked: true,
              setMarkReviewedClicked: false,
              confirmApproveWithoutReviewDialogIsOpen: false
            },
            () => this.currentForm && this.currentForm.submit()
          );
        }}
        onClose={() =>
          this.setState({ confirmApproveWithoutReviewDialogIsOpen: false })
        }
        confirm="Yes"
        cancel="No"
      />
    </>
  );

  renderDialogActions = ({
    hasBack,
    hasNext,
    hasApproveButton,
    submitInProgress,
    resourceupload,
    setPendingClicked,
    approveClicked,
    popupSteps,
    activeStep,
    splitStatus,
    classes
  }) => (
    <DialogActions style={{ borderTop: `1px solid rgba(0, 0, 0, 0.12)` }}>
      <div className={classes.leftWrapper}>
        {hasBack && (
          <Button
            onClick={this.handleBackForm}
            variant="outlined"
            color="primary"
            className={classes.secondaryButton}
          >
            Back
          </Button>
        )}
      </div>
      <>
        {hasNext && (
          <Button
            onClick={this.handleSaveAndClose}
            variant="outlined"
            color="primary"
            className={classes.secondaryButton}
            disabled={submitInProgress}
          >
            Save & Close
          </Button>
        )}
        {hasApproveButton && (
          <Button
            onClick={this.handleSetPending}
            color="primary"
            variant="outlined"
            className={classes.secondaryButton}
            disabled={resourceupload.batchStatus === 'P' || setPendingClicked}
          >
            Set as Pending
          </Button>
        )}
        {this.canShowReviewButton() && (
          <Button
            onClick={this.handleToggleReviewed}
            color="primary"
            variant="outlined"
            className={classes.secondaryButton}
            disabled={resourceupload.batchStatus === 'A'}
          >
            {this.getReviewButtonLabel()}
          </Button>
        )}
        {hasApproveButton && (
          <Button
            onClick={this.handleApprove}
            color="primary"
            variant="contained"
            className={classes.button}
            disabled={resourceupload.batchStatus === 'A' || approveClicked}
          >
            Approve
          </Button>
        )}
        {hasNext && (
          <Button
            onClick={this.handleNextForm}
            color="primary"
            variant="contained"
            className={classes.button}
            disabled={
              (popupSteps[activeStep].name === 'summary' &&
                resourceupload.batchStatus !== 'A') ||
              (popupSteps[activeStep].name === 'matching' &&
                splitStatus !== 'COMPLETED') ||
              submitInProgress
            }
          >
            Next
          </Button>
        )}
        {!hasNext && (
          <Button
            onClick={this.handleClose}
            color="primary"
            variant="contained"
            className={classes.button}
          >
            Close
          </Button>
        )}
      </>
    </DialogActions>
  );

  render() {
    const {
      activeStep,
      confirmDialogIsOpen,
      confirmUpdateDialogIsOpen,
      confirmUpdateAndCloseDialogIsOpen,
      openEmailModal,
      resourceupload,
      splitStatus,
      recipientsListSelected,
      recipientsList,
      popupSteps,
      submitInProgress,
      approveClicked,
      setPendingClicked,
      notificationMethod
    } = this.state;
    const { classes, isEdit, userProfile } = this.props;

    const specialTextForMatchingStepLeaveModal =
      popupSteps[activeStep].label === 'Matching' ? (
        <p>Your changes will be saved. Are you sure?</p>
      ) : (
        <p>Your changes will not be saved. Are you sure?</p>
      );

    const hasNext = popupSteps[activeStep]?.nextButton || false;
    const hasBack = popupSteps[activeStep]?.backButton || false;
    const hasApproveButton = popupSteps[activeStep]?.approveButton || false;

    return (
      <Fragment>
        <Dialog
          open
          aria-label="Upload document"
          maxWidth={false}
          onClose={(event, reason) => {
            if (reason === 'backdropClick') return null;
            if (reason === 'escapeKeyDown') return this.handleCloseClick();
          }}
          classes={{ paperWidthFalse: classes.paperWidthFalse }}
        >
          <DialogTitleWithCloseButton onClose={this.handleCloseClick}>
            {'Upload Document' +
              (resourceupload.resourceUploadId
                ? ' - ' + resourceupload.resourceUploadId
                : '') +
              (resourceupload.fileName ? ' - ' + resourceupload.fileName : '')}
          </DialogTitleWithCloseButton>

          {this.renderStepper(
            popupSteps,
            activeStep,
            classes,
            isEdit,
            resourceupload
          )}

          <DialogContent className={classes.dialogContent}>
            <EmailDialog
              open={openEmailModal}
              handleClose={this.handleCloseEmail}
              recipientsListSelected={recipientsListSelected}
              recipientsList={recipientsList}
              resourceuploadId={resourceupload.resourceUploadId}
              notificationMethod={notificationMethod}
              userProfile={userProfile}
            />
            <div
              className={
                activeStep === 4
                  ? classes.noPaddingContainer
                  : classes.stepContainer
              }
            >
              {this.getActiveStep(popupSteps)}
            </div>
            {this.renderConfirmModals(
              confirmDialogIsOpen,
              confirmUpdateDialogIsOpen,
              confirmUpdateAndCloseDialogIsOpen,
              resourceupload,
              specialTextForMatchingStepLeaveModal
            )}
          </DialogContent>

          {this.renderDialogActions({
            hasBack,
            hasNext,
            hasApproveButton,
            submitInProgress,
            resourceupload,
            setPendingClicked,
            approveClicked,
            popupSteps,
            activeStep,
            splitStatus,
            classes
          })}
        </Dialog>
      </Fragment>
    );
  }

  canShowReviewButton = () => {
    const { permissions = [] } = this.props;
    const { popupSteps, activeStep, isDocReviewEnabled } = this.state;

    const hasApproveButton = popupSteps[activeStep]?.approveButton;
    const hasAuthReviewDocumentPermission = permissions.includes(
      'AUTH_REVIEW_DOCUMENT'
    );

    return (
      hasApproveButton && isDocReviewEnabled && hasAuthReviewDocumentPermission
    );
  };

  getReviewButtonLabel = () => {
    const { resourceupload } = this.state;
    return resourceupload.reviewedBy !== null
      ? 'Mark as Unreviewed'
      : 'Mark as Reviewed';
  };

  /**
   * Save current step and close modal dialog
   */
  handleSaveAndClose = confirmUpdate => {
    const { resourceupload, activeStep, popupSteps } = this.state;
    const stepName = popupSteps[activeStep].name;

    // if we are updating a resourceupload that has an 'Active' status then open confirm dialog
    if (
      this.shouldConfirmUpdateOnSaveAndClose(
        confirmUpdate,
        resourceupload,
        activeStep
      )
    ) {
      this.setState({ confirmUpdateAndCloseDialogIsOpen: true });
      return;
    }

    this.setState(
      { closing: true },
      () => void this.executeSaveAndClose(stepName, resourceupload)
    );
  };

  executeSaveAndClose = async (stepName, resourceupload) => {
    // Trigger a submit to active form
    // This is needed because our modal action buttons are oustide the form
    // Do not submit the form on the Summary step because we don't need to approve the batch on save & close
    if (stepName === 'summary') {
      await this.handleSummarySaveAndClose(resourceupload);
      return;
    }

    this.handleNonSummarySaveAndClose();
  };

  shouldConfirmUpdateOnSaveAndClose = (
    confirmUpdate,
    resourceupload,
    activeStep
  ) => {
    if (confirmUpdate === true) return false;
    if (!resourceupload || !this.currentForm) return false;

    const formState = this.currentForm.getState();
    const isActiveDirty =
      resourceupload.batchStatus === 'A' && formState.dirty && activeStep < 2;
    const isPendingProfileChange =
      activeStep === 0 &&
      resourceupload.batchStatus === 'P' &&
      resourceupload.documentProfileId !==
        formState.values.metadata.documentProfileId;

    return isActiveDirty || isPendingProfileChange;
  };

  handleSummarySaveAndClose = async resourceupload => {
    const didPersist = await this.persistEmailNotifyFlagOnSummary(
      resourceupload
    );
    if (didPersist) return;

    if (!this.currentForm || !this.currentForm.getState().submitting) {
      this.handleClose();
    }
  };

  handleNonSummarySaveAndClose = () => {
    this.currentForm && this.currentForm.submit();
    //Close modal dialog when save&close is clicked even if submit is not successful
    if (
      !this.currentForm ||
      (!this.currentForm.getState().submitting &&
        !this.currentForm.getState().submitSucceeded)
    ) {
      this.handleClose();
    }
  };

  persistEmailNotifyFlagOnSummary = async resourceupload => {
    const sendEmails = Boolean(
      this.currentForm?.getState?.().values?.metadata?.sendEmails
    );
    const currentFlag = Boolean(resourceupload?.emailNotifyFlag);

    if (!resourceupload?.resourceUploadId || sendEmails === currentFlag) {
      return false;
    }

    try {
      const updatedResourceupload = await this.updateEmailNotifyFlag(
        resourceupload.resourceUploadId,
        sendEmails
      );
      this.setState(
        { resourceupload: updatedResourceupload },
        this.handleClose
      );
      return true;
    } catch (e) {
      this.setState({ closing: false });
      this.props.showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(e) }
      });
      return true;
    }
  };

  buildResourceUploadMetadata = (resourceupload, overrides = {}) => {
    return {
      documentDate: resourceupload.documentDate,
      dueDate: resourceupload.dueDate,
      documentTitle: resourceupload.documentTitle,
      documentProfileId: resourceupload.documentProfileId,
      documentTypeId: resourceupload.documentTypeId,
      profileData: resourceupload.profileData,
      fileName: resourceupload.fileName,
      year: resourceupload.year,
      quarter: resourceupload.quarter,
      fundFamilyId: resourceupload.fundFamilyId,
      fundIds: resourceupload.fundIds,
      allInvestors: resourceupload.allInvestors,
      ...overrides
    };
  };

  updateResourceUploadMetadata = async (resourceupload, metadataOverrides) => {
    const formData = new FormData();
    formData.append('resourceUploadId', resourceupload.resourceUploadId);
    formData.append(
      'metadata',
      JSON.stringify(
        this.buildResourceUploadMetadata(resourceupload, metadataOverrides)
      )
    );
    return await ResourceUploadApi.updateResourceUpload(formData);
  };

  updateEmailNotifyFlag = async (resourceUploadId, emailNotifyFlag) => {
    return await ResourceUploadApi.updateEmailNotifyFlag(
      resourceUploadId,
      emailNotifyFlag
    );
  };

  /**
   *  Save current step and go to next one
   */
  handleNextForm = confirmUpdate => {
    const { resourceupload, activeStep, targetStep } = this.state;

    // if we are updating a resourceupload that has an 'Active' status then open confirm dialog
    if (
      (confirmUpdate !== true &&
        resourceupload &&
        resourceupload.batchStatus === 'A' &&
        this.currentForm &&
        this.currentForm.getState().dirty &&
        activeStep < 2) ||
      (confirmUpdate !== true &&
        activeStep === 0 &&
        resourceupload &&
        resourceupload.batchStatus === 'P' &&
        resourceupload.documentProfileId !==
          this.currentForm.getState().values.metadata.documentProfileId)
    ) {
      this.setState({ confirmUpdateDialogIsOpen: true });
      return;
    }

    // Trigger a submit to active form
    // This is needed because our modal action buttons are oustide the form
    if (this.currentForm) {
      //const batchToValidate = resourceupload;
      //const formState = this.currentForm.getState();

      // if (activeStep === 0) {
      //   // We are on the first step (the details) we need to get the changed values from the form and apply validation on them not on initial values
      //   const formStateValues = this.currentForm.getState().values;
      //   batchToValidate.documentTitle = formStateValues.metadata.documentTitle;
      //   batchToValidate.profileData.documentSecurityId =
      //     formStateValues.metadata.profileData.documentSecurityId;
      //   batchToValidate.documentDate = formStateValues.metadata.documentDate;
      //   batchToValidate.profileData.categoryId =
      //     formStateValues.metadata.profileData.categoryId;
      //   batchToValidate.documentTypeId =
      //     formStateValues.metadata.documentTypeId;
      // }

      //special case for validating of resourceuploads uploaded via API
      //prevent validation if no change is made on form
      //and allow to go next without submitting if the batch is not valide
      if (resourceupload.uploadVia && resourceupload.uploadVia === 'API') {
        this.goToNextStep(resourceupload);
      } else {
        this.currentForm.submit();
      }
    } else {
      this.setState({
        activeStep:
          targetStep !== null && targetStep >= 0 ? targetStep : activeStep + 1,
        targetStep: null
      });
    }
  };

  handleBackForm = () => {
    const { activeStep, resourceupload } = this.state;
    if (activeStep > 0) {
      this.currentForm = undefined;
      const steps = this.getPopupSteps(resourceupload.allInvestors);
      this.setState({
        activeStep: activeStep - 1,
        popupSteps: steps,
        fundLevelDocumentsChecked: resourceupload.allInvestors,
        submitInProgress: false, //enable action buttons if returning to previous step
        closing: false,
        approveClicked: false, // in case approve clicked on Summary Step and there were errors and then back button is clicked
        setPendingClicked: false,
        setMarkReviewedClicked: false
      });
    }
  };

  handleStep = index => {
    this.setState(
      {
        targetStep: index
      },
      () => {
        this.handleNextForm();
      }
    );
  };

  handleCloseClick = () => {
    this.setState({ confirmDialogIsOpen: true });
  };

  handleConfirmDialogClose = () => {
    this.setState({ confirmDialogIsOpen: false });
  };

  handleConfirm = () => {
    this.props.history.push(resolveRedirectTo('list', this.props.basePath));
  };

  /**
   * Close modal dialog
   */
  handleClose = () => {
    this.props.history.push(resolveRedirectTo('list', this.props.basePath));
  };

  handleConfirmUpdateDialogClose = () => {
    this.setState({
      confirmUpdateDialogIsOpen: false,
      confirmUpdateAndCloseDialogIsOpen: false
    });
  };

  handleConfirmUpdate = () => {
    if (this.state.confirmUpdateDialogIsOpen) {
      this.handleNextForm(true);
    } else {
      this.handleSaveAndClose(true);
    }
    this.handleConfirmUpdateDialogClose();
  };

  onFormInit = form => {
    this.currentForm = form;
  };

  /**
   * Post form submit callback.
   * Will close the modal if closing === true
   * Otherwise, go to next step
   *
   * @param resourceupload Modified resourceupload object
   * @param sendEmails
   */
  onSubmitEnd = async (resourceupload, sendEmails = false) => {
    if (this.state.closing) {
      this.handleClose();
    } else {
      if (this.state.approveClicked) {
        return await this.approveDocuments(resourceupload, sendEmails);
      }
      if (this.state.setPendingClicked) {
        return await this.setPending(resourceupload);
      }

      // Goto next step
      this.goToNextStep(resourceupload);
    }
  };

  goToNextStep = resourceupload => {
    const { activeStep, targetStep } = this.state;
    this.currentForm = undefined;
    this.setState({
      resourceupload,
      activeStep:
        targetStep !== null && targetStep >= 0 ? targetStep : activeStep + 1,
      targetStep: null,
      submitInProgress: false //enable action buttons if sumbit is success
    });
  };

  handleSetPending = () => {
    this.setState(
      {
        setPendingClicked: true
      },
      () => {
        this.currentForm && this.currentForm.submit();
      }
    );
  };

  handleApprove = () => {
    const { resourceupload, isDocReviewEnabled } = this.state;

    if (resourceupload.reviewedBy === null && isDocReviewEnabled) {
      this.setState({ confirmApproveWithoutReviewDialogIsOpen: true });
      return;
    }

    this.setState(
      {
        approveClicked: true,
        setMarkReviewedClicked: resourceupload.reviewedBy !== null
      },
      () => {
        this.currentForm && this.currentForm.submit();
      }
    );
  };

  handleToggleReviewed = async () => {
    const { resourceupload } = this.state;
    const { userProfile } = this.props;
    this.setState({ setMarkReviewedClicked: true });
    try {
      const newStatus = resourceupload.reviewedBy ? 'UNREVIEWED' : 'REVIEWED';
      await ResourceUploadApi.setDocumentBatchReviewedByStatus(
        resourceupload.resourceUploadId,
        newStatus
      );
      this.setState({
        resourceupload: {
          ...resourceupload,
          reviewedBy: newStatus === 'REVIEWED' ? userProfile.userId : null
        },
        setMarkReviewedClicked: false
      });
      this.props.showNotification(
        newStatus === 'REVIEWED'
          ? 'Document is reviewed.'
          : 'Document is unreviewed.',
        'info'
      );
    } catch (error) {
      this.props.showNotification('Error updating review status.', 'error');
      this.setState({ setMarkReviewedClicked: false });
    }
  };

  setPending = async resourceupload => {
    try {
      //set batch status to Active
      await ResourceUploadApi.setBatchStatus(
        resourceupload.resourceUploadId,
        'P'
      );
      this.setState({
        resourceupload: {
          ...resourceupload,
          batchStatus: 'P',
          reviewedBy: null
        },
        setPendingClicked: false,
        setMarkReviewedClicked: false
      });
      this.props.showNotification(
        'ra.notification.resource_upload_pending',
        'info'
      );
    } catch (e) {
      this.setState({
        setPendingClicked: false
      });
      this.props.showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(e) }
      });
    }
  };

  approveDocuments = async (resourceupload, sendEmails) => {
    const { userProfile } = this.props;
    const { setMarkReviewedClicked } = this.state;
    try {
      //set batch status to Active
      await ResourceUploadApi.setBatchStatus(
        resourceupload.resourceUploadId,
        'A'
      );
      if (this.currentForm && typeof this.currentForm.change === 'function') {
        this.currentForm.change('metadata.sendEmails', false);
      }
      this.setState({
        resourceupload: {
          ...resourceupload,
          batchStatus: 'A',
          emailNotifyFlag: false,
          reviewedBy:
            setMarkReviewedClicked || resourceupload.reviewedBy !== null
              ? userProfile.userId
              : null
        },
        approveClicked: false
      });

      try {
        const updatedResourceupload = await this.updateEmailNotifyFlag(
          resourceupload.resourceUploadId,
          false
        );
        this.setState(prevState => ({
          resourceupload: {
            ...prevState.resourceupload,
            ...updatedResourceupload,
            batchStatus: 'A',
            reviewedBy:
              setMarkReviewedClicked || resourceupload.reviewedBy !== null
                ? userProfile.userId
                : null
          }
        }));
      } catch (e) {
        this.props.showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(e) }
        });
      }

      let message = 'ra.notification.resource_upload_approved';
      if (sendEmails) {
        try {
          await ResourceUploadApi.notify(resourceupload.resourceUploadId);
          message = 'ra.notification.resource_upload_approved_email';
          this.props.showNotification(message, 'info');
        } catch (e) {
          this.props.showNotification(
            'ra.notification.resource_upload_approved',
            'info'
          );
          setTimeout(() => {
            this.props.showNotification(getIcError(e), 'error');
          }, 1000);
        }
      } else {
        this.props.showNotification(
          'ra.notification.resource_upload_approved',
          'info'
        );
      }
    } catch (e) {
      if (resourceupload.reviewedBy !== null) {
        this.setState({
          setMarkReviewedClicked: true
        });
      }
      this.setState({
        resourceupload: {
          ...resourceupload,
          reviewedBy: null
        },
        approveClicked: false,
        setMarkReviewedClicked: false
      });
      this.props.showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(e) }
      });
    }
  };

  /**
   * Used on step 1 (DetailsStep) if Document_Tag = true else on step 2 (FundsStep)
   * In order to post/put resourceUpload.allInvestor = true or false
   */
  handleFundLevelDocumentsChanged = () => {
    const { fundLevelDocumentsChecked } = this.state;
    const steps = this.getPopupSteps(!fundLevelDocumentsChecked);
    this.setState({
      fundLevelDocumentsChecked: !fundLevelDocumentsChecked,
      popupSteps: steps
    });
    this.handleUploadChange(true);
  };

  handleUploadChange = newValue => {
    this.setState({
      uploadChanged: newValue
    });
  };

  /**Validate the batch */
  validateBatch = values => {
    //validate only batches uploaded via API
    if (values.uploadVia !== 'API') {
      return true;
    } else {
      // For now we never allow to save a batch uploaded via API as the server side cannot handle missing values especially filename
      return false;
    }
    // if (
    //   !values.documentTitle ||
    //   !values.profileData.documentSecurityId ||
    //   !values.documentDate ||
    //   !values.profileData.categoryId ||
    //   !values.documentTypeId ||
    //   values.documentTypeId === 0
    // ) {
    //   return false;
    // }
    // return true;
  };
}

const mapDispatchToProps = {
  showNotification
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(ResourceUploadCreate));
